<ng-content></ng-content>
<ng-template ngFor [ngForOf]="displayedAreas" let-index="index" let-last="last">
  <div #gutterEls class="mtx-split-gutter" [ngClass]="['mat-' + color]"
       *ngIf="last === false"
       [style.flex-basis.px]="gutterSize"
       [style.order]="index * 2 + 1"
       (mousedown)="startDragging($event, index * 2 + 1, index + 1)"
       (touchstart)="startDragging($event, index * 2 + 1, index + 1)"
       (mouseup)="clickGutter($event, index + 1)"
       (touchend)="clickGutter($event, index + 1)">
    <div class="mtx-split-gutter-handle"></div>
  </div>
</ng-template>
